export default __webpack_public_path__ + "static/media/kuchnia9.33bd9d74.jpg";